import React, { useRef } from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import { CAMPOS_RISCO } from "./matrizRiscosData";
import "./RelatorioMatrizRiscosPrint.css";

const valor = (conteudo) => String(conteudo ?? "").trim() || "-";
const LARGURAS_COLUNAS_PDF = ["3%", "8%", "12%", "13%", "13%", "13%", "8%", "6%", "17%", "7%"];
const ID_QUADRO_IMPRESSAO = "quadro-impressao-matriz-riscos";

const ESTILOS_PDF_MATRIZ_RISCOS = `
  @page { size: A4 landscape; margin: 0; }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: #fff; color: #071b31; font-family: Arial, sans-serif; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .pagina-pdf-matriz { width: 297mm; height: 210mm; margin: 0; padding: 15mm 15mm 6px; overflow: hidden; break-after: page; page-break-after: always; }
  .pagina-pdf-matriz:last-child { break-after: auto; page-break-after: auto; }
  table { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .cabecalho-relatorio-matriz td { border: 1px solid #153d64; padding: 5px; text-align: center; }
  .cabecalho-relatorio-matriz td:nth-child(1) { width: 26mm; }
  .cabecalho-relatorio-matriz td:nth-child(3) { width: 38mm; }
  .cabecalho-relatorio-matriz img { max-width: 24mm; max-height: 14mm; }
  .cabecalho-relatorio-matriz strong, .cabecalho-relatorio-matriz span { display: block; }
  .cabecalho-relatorio-matriz td:nth-child(2) strong { font-size: 16px; color: #0b4b78; }
  .cabecalho-relatorio-matriz span { margin-top: 3px; font-size: 9px; }
  .tabela-relatorio-matriz { font-size: 8px; }
  .tabela-relatorio-matriz th, .tabela-relatorio-matriz td { border: 1px solid #42713e; padding: 4px 3px; text-align: center; vertical-align: middle; overflow-wrap: anywhere; }
  .tabela-relatorio-matriz th { background: #0b4774; color: #fff; font-size: 8.2px; }
  .tabela-relatorio-matriz .linha-cabecalho-documento > th { border: 0; padding: 0 0 4mm; background: #fff; color: #071b31; }
  .tabela-relatorio-matriz .cabecalho-relatorio-matriz td { border: 1px solid #153d64; padding: 5px; }
  .tabela-relatorio-matriz tbody tr:nth-child(even) { background: #f4f7f2; }
  .tabela-relatorio-matriz thead { display: table-header-group; }
  .tabela-relatorio-matriz tr { break-inside: avoid; page-break-inside: avoid; }
`;

function imprimirPdfMatrizRiscos(elemento, nomeArquivo) {
  if (!elemento) return;
  const tabela = elemento.querySelector(".tabela-relatorio-matriz");
  const cabecalhoTabela = tabela?.querySelector("thead")?.outerHTML || "";
  const definicaoColunas = Array.from(tabela?.children || []).find((elementoFilho) => elementoFilho.tagName === "COLGROUP")?.outerHTML || "";
  const corpoTabela = Array.from(tabela?.children || []).find((elementoFilho) => elementoFilho.tagName === "TBODY");
  const linhas = Array.from(corpoTabela?.children || []);
  if (!tabela || !cabecalhoTabela || linhas.length === 0) return;

  document.getElementById(ID_QUADRO_IMPRESSAO)?.remove();
  const quadroImpressao = document.createElement("iframe");
  quadroImpressao.id = ID_QUADRO_IMPRESSAO;
  quadroImpressao.title = "Impressão da Matriz de Riscos";
  Object.assign(quadroImpressao.style, { position: "fixed", right: "0", bottom: "0", width: "1px", height: "1px", border: "0", opacity: "0", pointerEvents: "none" });
  document.body.appendChild(quadroImpressao);

  const janelaImpressao = quadroImpressao.contentWindow;
  const documentoImpressao = quadroImpressao.contentDocument;
  documentoImpressao.open();
  documentoImpressao.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${nomeArquivo}</title><style>${ESTILOS_PDF_MATRIZ_RISCOS}</style></head><body></body></html>`);
  documentoImpressao.close();

  function criarPagina() {
    const pagina = documentoImpressao.createElement("section");
    pagina.className = "pagina-pdf-matriz";
    pagina.innerHTML = `<table class="tabela-relatorio-matriz">${definicaoColunas}${cabecalhoTabela}<tbody></tbody></table>`;
    documentoImpressao.body.appendChild(pagina);
    return pagina;
  }

  let paginaAtual = criarPagina();
  const imagensCabecalho = Array.from(paginaAtual.querySelectorAll("img"));
  Promise.all(imagensCabecalho.map((imagem) => imagem.complete ? Promise.resolve() : new Promise((resolve) => {
    imagem.addEventListener("load", resolve, { once: true });
    imagem.addEventListener("error", resolve, { once: true });
  }))).then(() => {
    linhas.forEach((linha) => {
      let corpoPagina = Array.from(paginaAtual.querySelector(".tabela-relatorio-matriz").children).find((elementoFilho) => elementoFilho.tagName === "TBODY");
      corpoPagina.insertAdjacentHTML("beforeend", linha.outerHTML);
      const linhaInserida = corpoPagina.lastElementChild;
      const limiteInferior = paginaAtual.getBoundingClientRect().bottom - 6;

      if (linhaInserida.getBoundingClientRect().bottom > limiteInferior && corpoPagina.children.length > 1) {
        linhaInserida.remove();
        paginaAtual = criarPagina();
        corpoPagina = Array.from(paginaAtual.querySelector(".tabela-relatorio-matriz").children).find((elementoFilho) => elementoFilho.tagName === "TBODY");
        corpoPagina.insertAdjacentHTML("beforeend", linha.outerHTML);
      }
    });

    janelaImpressao.onafterprint = () => quadroImpressao.remove();
    janelaImpressao.focus();
    janelaImpressao.print();
  });
}

export default function RelatorioMatrizRiscosPrint({ cadastro, onVoltar }) {
  const nomeArquivo = "RQ-1.6-MATRIZ-DE-RISCOS";
  const paginaRef = useRef(null);
  useNomeArquivoPdf(nomeArquivo);

  if (!cadastro) return null;

  return (
    <div className="relatorio-matriz-riscos-print">
      <div className="acoes-relatorio-matriz">
        <button type="button" onClick={onVoltar}>Voltar</button>
        <button type="button" className="botao-pdf-matriz" onClick={() => imprimirPdfMatrizRiscos(paginaRef.current, nomeArquivo)}>Salvar como PDF</button>
      </div>
      <main ref={paginaRef} className="pagina-relatorio-matriz">
        <table className="tabela-relatorio-matriz">
          <colgroup>{LARGURAS_COLUNAS_PDF.map((largura, indice) => <col key={indice} style={{ width: largura }} />)}</colgroup>
          <thead>
            <tr className="linha-cabecalho-documento">
              <th colSpan={CAMPOS_RISCO.length + 1}>
                <table className="cabecalho-relatorio-matriz">
                  <tbody><tr><td className="logo-relatorio-matriz"><LogoRelatorio alt="Logo da empresa" /></td><td><strong>MATRIZ DE RISCOS</strong><span>Sistema de Gestão da Qualidade</span></td><td><strong>RQ 1.6</strong><span>Revisão {valor(cadastro.revisao)}</span><span>Atualizado em {valor(cadastro.atualizadoEmDocumento)}</span></td></tr></tbody>
                </table>
              </th>
            </tr>
            <tr><th>Item</th>{CAMPOS_RISCO.map(([campo, titulo]) => <th key={campo}>{titulo}</th>)}</tr>
          </thead>
          <tbody>{(cadastro.riscos || []).map((risco, indice) => <tr key={risco.id || indice}><td>{indice + 1}</td>{CAMPOS_RISCO.map(([campo]) => <td key={campo}>{valor(risco[campo])}</td>)}</tr>)}</tbody>
        </table>
      </main>
    </div>
  );
}
